<script setup>
import { useI18n } from 'vue-i18n';
import en from './en.json';
import ru from './ru.json';

defineProps({
  channel: { type: String, default: '' },
  inboxId: { type: Number, default: null },
  sourceMode: { type: String, default: 'exact' },
  catalog: { type: Object, required: true },
  appointmentAvailable: { type: Boolean, default: true },
});
const emit = defineEmits([
  'update:channel',
  'update:inboxId',
  'update:sourceMode',
]);
const { t } = useI18n({ useScope: 'local', messages: { en, ru } });
</script>

<template>
  <div class="space-y-2">
    <label class="block text-xs"
      >{{ t('channel') }}
      <select
        :value="channel"
        class="w-full mt-1 text-sm"
        @change="
          emit('update:channel', $event.target.value);
          emit('update:inboxId', null);
        "
      >
        <option value="">{{ t('choose') }}</option>
        <option v-for="item in catalog.channels" :key="item" :value="item">
          {{ t(`channel_${item}`) }}
          {{
            catalog.supported_runtime_channels?.includes(item)
              ? ''
              : ` — ${t('editor.draftCapability')}`
          }}
        </option>
      </select>
    </label>
    <label class="block text-xs">
      {{ t('runtime.sourceMode') }}
      <select
        :value="sourceMode"
        class="w-full mt-1 text-sm"
        @change="
          emit('update:sourceMode', $event.target.value);
          emit('update:inboxId', null);
        "
      >
        <option value="exact">{{ t('runtime.exactSource') }}</option>
        <option value="appointment" :disabled="!appointmentAvailable">
          {{ t('runtime.appointmentSource') }}
        </option>
      </select>
    </label>
    <label v-if="sourceMode !== 'appointment'" class="block text-xs">
      <span>{{ t('inbox') }}</span>
      <select
        :value="inboxId"
        class="w-full mt-1 text-sm"
        @change="
          emit(
            'update:inboxId',
            $event.target.value ? Number($event.target.value) : null
          )
        "
      >
        <option value="">{{ t('choose') }}</option>
        <option
          v-if="
            inboxId &&
            !catalog.inboxes.some(
              item => item.id === inboxId && item.channel === channel
            )
          "
          :value="inboxId"
          disabled
        >
          {{ t('sourceMissing') }}
        </option>
        <option
          v-for="item in catalog.inboxes.filter(
            inbox => inbox.channel === channel
          )"
          :key="item.id"
          :value="item.id"
        >
          {{ item.name }}
        </option>
      </select>
    </label>
    <p
      v-if="channel && !catalog.supported_runtime_channels?.includes(channel)"
      role="status"
      class="text-xs leading-5 text-n-amber-11"
    >
      {{ t('editor.channelUnsupported') }}
    </p>
    <p
      v-if="sourceMode === 'appointment'"
      class="text-xs leading-5 text-n-slate-11"
    >
      {{ t('editor.routingHint') }}
    </p>
    <p
      v-if="
        channel &&
        sourceMode !== 'appointment' &&
        !catalog.inboxes.some(item => item.channel === channel)
      "
      class="text-xs leading-5 text-n-slate-11"
    >
      {{ t('sourcesEmpty') }}
    </p>
  </div>
</template>
